module.exports = __webpack_public_path__ + "img/world1.8e2b84da.png";